import { render, staticRenderFns } from "./loadingPoints.vue?vue&type=template&id=263e5554&"
import script from "./loadingPoints.vue?vue&type=script&lang=js&"
export * from "./loadingPoints.vue?vue&type=script&lang=js&"
import style0 from "./loadingPoints.vue?vue&type=style&index=0&id=263e5554&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports